import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ChangePasswordService {
  constructor(private http: HttpClient) {}

  resetPassword(
    old_password: string,
    new_password: string,
    new_password_confirmation: string
  ): Observable<any> {
    return this.http.post(environment.Server_URL + '/change-password', {
      old_password,
      new_password,
      new_password_confirmation,
    });
  }
}
